import config from "./config.json";
import modules from "../../../modules/componentLoader";
import "@tinqin/design-uneo-site-cp/less/phones.less";

const getConfig = async () => {
    //preloading UI feature before returning Widget UI configuration
    await modules.load("article");
    await modules.load("reimbursement");
    await modules.load("smooth-resizing");
    return config;
};

export { getConfig };
